import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IntegrationFormButtonsWrapper = styled.div`
  padding-top: ${Spacing.S24};
  position: sticky;
  bottom: 0;
`
